/**
 * tdesign v0.46.2
 * (c) 2022 tdesign
 * @license MIT
 */

import './type.js';

var KeyboardDirection = /* @__PURE__ */function (KeyboardDirection2) {
  KeyboardDirection2[KeyboardDirection2["left"] = 37] = "left";
  KeyboardDirection2[KeyboardDirection2["up"] = 38] = "up";
  KeyboardDirection2[KeyboardDirection2["right"] = 39] = "right";
  KeyboardDirection2[KeyboardDirection2["down"] = 40] = "down";
  return KeyboardDirection2;
}(KeyboardDirection || {});
var EPickerCols = /* @__PURE__ */function (EPickerCols2) {
  EPickerCols2["hour"] = "hour";
  EPickerCols2["minute"] = "minute";
  EPickerCols2["second"] = "second";
  EPickerCols2["meridiem"] = "meridiem";
  return EPickerCols2;
}(EPickerCols || {});

export { EPickerCols, KeyboardDirection };
//# sourceMappingURL=interface.js.map
